import ApiV1 from "@/configs/axios/ApiV1";

export function CheckTelegramStatus() {
  return ApiV1.post("/myNotification/telegram/check");
}

export function GenerateTelegramCode(data) {
  return ApiV1.post("/myNotification/telegram/generateCode", data);
}

export function VerifyTelegramCode(data) {
  return ApiV1.post("/myNotification/telegram/verifyCode", data);
}

export function CancelTelegram() {
  return ApiV1.post("/myNotification/telegram/cancel");
}

export function ActivateTelegram() {
  return ApiV1.post("/myNotification/telegram/activate");
}

export function CheckEmailStatus() {
  return ApiV1.post("/myNotification/email/check");
}

export function EnableEmail(data) {
  return ApiV1.post("/myNotification/email/enable", data);
}

export function ActivateEmail() {
  return ApiV1.post("/myNotification/email/activate");
}

export function CancelEmail() {
  return ApiV1.post("/myNotification/email/cancel");
}

/**
 * Пагинация здесь курсорная, не нумерованная: nrk-notification не принимает
 * page/per_page, а отдаёт в ответе nextId (notification_id последнего элемента
 * страницы) и end. Чтобы получить следующую порцию, nextId передаётся обратно
 * как max_id — бэкенд выбирает записи строго старше курсора.
 * count на бэкенде ограничен: min 1, max 50.
 */
export function GetNotifications(count = 20, not_viewed = null, max_id = null) {
  return ApiV1.get("/myNotification/notifications", {
    params: { count, not_viewed, max_id },
  });
}

export function CountNotViewedNotifications() {
  return ApiV1.get("/myNotification/counter", {
    params: { type: "not_viewed" },
  });
}

/**
 * Без uuid отмечает прочитанными все уведомления сотрудника. На бэкенде
 * выставляются сразу read_at и is_viewed, а счётчик в колокольчике считает
 * именно непросмотренные — поэтому после вызова его нужно перезапросить.
 */
export function MarkNotificationsAsRead(uuid = null) {
  return ApiV1.post(`/myNotification/markAsRead${uuid ? `/${uuid}` : ""}`);
}
